<script setup>
const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
})

const titleContent = ref(null)
const decorationContainer = ref(null)

onMounted(() => {
  positionDecorationImage(props.block.parolaTarget)
})

function positionDecorationImage(targetWord) {
  if (titleContent.value && decorationContainer.value) {
    const htmlContent = titleContent.value
    const decorationContainerElement = decorationContainer.value

    const targetWordIndex = htmlContent.innerHTML.indexOf(targetWord)
    if (targetWordIndex === -1) {
      // console.warn(`Word "${targetWord}" not found in the content.`)
      return
    }

    const beforeTargetWord = htmlContent.innerHTML.substring(0, targetWordIndex)
    const afterTargetWord = htmlContent.innerHTML.substring(
      targetWordIndex + targetWord.length,
    )

    htmlContent.innerHTML = `${beforeTargetWord}<span class="target-word">${targetWord}</span>${afterTargetWord}`

    const targetWordElement = htmlContent.querySelector('.target-word')
    if (targetWordElement) {
      targetWordElement.appendChild(decorationContainerElement)
    }
  }
}
</script>

<template>
  <div class="title-double-col-text p-bottom-xl-1 p-top-xl-1 max">
    <div class="container max-content">
      <!-- eslint-disable vue/no-v-html -->
      <div class="titles-section">
        <div
          ref="titleContent"
          class="title title-base"
          v-html="block.titolo"
        />
        <div
          v-if="block.immagineDecorativa && type === 'custom-position'"
          ref="decorationContainer"
          :class="['decoration-img-container', type]"
        >
          <DecorationImage
            :image="block.immagineDecorativa.immagine"
            :type="block.immagineDecorativa.titolo"
          />
        </div>
        <div
          v-if="block.immagineDecorativa && type === 'default'"
          :class="['decoration-img-container', type]"
        >
          <DecorationImage
            :image="block.immagineDecorativa.immagine"
            :type="block.immagineDecorativa.titolo"
          />
        </div>
        <div
          v-if="block.sottotitolo"
          class="subtitle title-base2"
          v-html="block.sottotitolo"
        />
      </div>
      <div class="txt-section text-s-1-b">
        <div class="left">
          <div v-html="block.primaColonna" />
        </div>
        <div class="right">
          <div v-html="block.secondaColonna" />
          <div
            v-if="block.immagineDecorativa && type === 'on-text'"
            :class="['decoration-img-container', type]"
          >
            <DecorationImage
              :image="block.immagineDecorativa.immagine"
              :type="block.immagineDecorativa.titolo"
            />
          </div>
        </div>
      </div>
      <DefaultBtn
        v-if="block.cta?.file"
        :text="block.cta.testo"
        :content="block.cta.file.url"
        class="button-round-1 with-icon is-orange"
      />
      <DefaultLink
        v-if="block.cta?.link"
        class="icon-link text-custom is-semi-bold"
        :text="block.cta.testo"
        :content="block.cta.link"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleDoubleColText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
